/**
 * A global namespace for aria-selected.
 */
const ariaSelected = 'aria-selected';
export default ariaSelected;
